import React from 'react';
import { Card, Icon } from 'ui';
import DateFormat from 'constants/date_format';

const AttemptsList = ({ attempts, userName }) => {
  const formatDate = date => moment(date).format(DateFormat.LONG_AT_TIME);

  return (
    <>
      <Card className="LearnerOverview-listTable">
        <Card.Content>
          {attempts.length > 0 && (
            <table
              className="DataTable Table tablesaw tablesaw-stack w-fill"
              data-tablesaw-mode="stack"
            >
              <thead>
                <tr>
                  <th>
                    <span className="pl-16">
                      {t(
                        'practice.on_demand_practice.overview.attempts_table.name_header',
                      )}
                    </span>
                  </th>
                  <th name="createdAt">
                    <span className="pl-16">
                      {t(
                        'practice.on_demand_practice.overview.learner_page.completions',
                      )}
                      <Icon
                        name="triangle_down"
                        className="LearnerOverview-arrow"
                      />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {attempts.map(attempt => (
                  <tr key={attempt.id}>
                    <td>
                      <span className="pl-16">{userName}</span>
                    </td>
                    <td>
                      <time className="pl-16">
                        {formatDate(attempt.createdAt)}
                      </time>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card.Content>
      </Card>
    </>
  );
};

export default AttemptsList;
